 
const newModel = () => {
    return {
        baocaoKtxhId: null,
        sttBaocao: null,
        maChiTieu: null,
        tenChiTieu: null,
        donViTinh: null,
        thucHienNamTruoc: null,
        keHoachNam: null,
        thucHienThang: null,
        thucHienThangSoVoiKeHoach: null,
        soVoiCungKyNamTruoc: null,
        thucHienLuyKeDenThangBc: null,
        uocThucHienThangKeTiep: null,
        uocThucHienLuyKe: null,
        uocThucHienLuyKeSoVoiKeHoach: null,
        ghiChu: null,
        idKy: null,
        tenKy: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null,
    }
}

const newFEModel = () => {
    return {
        baocaoKtxhId: null,
        sttBaocao: null,
        maChiTieu: null,
        tenChiTieu: null,
        donViTinh: null,
        thucHienNamTruoc: null,
        keHoachNam: null,
        thucHienThang: null,
        thucHienThangSoVoiKeHoach: null,
        soVoiCungKyNamTruoc: null,
        thucHienLuyKeDenThangBc: null,
        uocThucHienThangKeTiep: null,
        uocThucHienLuyKe: null,
        uocThucHienLuyKeSoVoiKeHoach: null,
        ghiChu: null,
        idKy: null,
        stt: null,
        enabled: null,

    }
}
             
const fromJson = (item) => {
    return {
        baocaoKtxhId: item.baocaoKtxhId,
        sttBaocao: item.sttBaocao,
        maChiTieu: item.maChiTieu,
        tenChiTieu: item.tenChiTieu,
        donViTinh: item.donViTinh,
        thucHienNamTruoc: item.thucHienNamTruoc,
        keHoachNam: item.keHoachNam,
        thucHienThang: item.thucHienThang,
        thucHienThangSoVoiKeHoach: item.thucHienThangSoVoiKeHoach,
        soVoiCungKyNamTruoc: item.soVoiCungKyNamTruoc,
        thucHienLuyKeDenThangBc: item.thucHienLuyKeDenThangBc,
        uocThucHienThangKeTiep: item.uocThucHienThangKeTiep,
        uocThucHienLuyKe: item.uocThucHienLuyKe,
        uocThucHienLuyKeSoVoiKeHoach: item.uocThucHienLuyKeSoVoiKeHoach,
        ghiChu: item.ghiChu,
        idKy: item.idKy,
        tenKy: item.tenKy,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        dateModified: item.dateModified,
        isDeleted: item.isDeleted,
        dateDeleted: item.dateDeleted,
        userCreated: item.userCreated,
        userModified: item.userModified,
        userDeleted: item.userDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        baocaoKtxhId: item.baocaoKtxhId,
        sttBaocao: item.sttBaocao,
        maChiTieu: item.maChiTieu,
        tenChiTieu: item.tenChiTieu,
        donViTinh: item.donViTinh,
        thucHienNamTruoc: item.thucHienNamTruoc,
        keHoachNam: item.keHoachNam,
        thucHienThang: item.thucHienThang,
        thucHienThangSoVoiKeHoach: item.thucHienThangSoVoiKeHoach,
        soVoiCungKyNamTruoc: item.soVoiCungKyNamTruoc,
        thucHienLuyKeDenThangBc: item.thucHienLuyKeDenThangBc,
        uocThucHienThangKeTiep: item.uocThucHienThangKeTiep,
        uocThucHienLuyKe: item.uocThucHienLuyKe,
        uocThucHienLuyKeSoVoiKeHoach: item.uocThucHienLuyKeSoVoiKeHoach,
        ghiChu: item.ghiChu,
        idKy: item.idKy,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        maChiTieu: null,
        tenChiTieu: null,
        idKy: null,
    }

}

const newSearchModel = (item) => {
    return {
        maChiTieu: item.maChiTieu,
        tenChiTieu: item.tenChiTieu,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const newExportModel = () => {
    return {
        idKy: null,
    }

}

const errorsExport = () => {
    return {
        idKy: null,
    }

}

const errors = () => {
    return {
        sttBaocao: null,
        maChiTieu: null,
        tenChiTieu: null,
        donViTinh: null,
        thucHienNamTruoc: null,
        keHoachNam: null,
        thucHienThang: null,
        thucHienThangSoVoiKeHoach: null,
        soVoiCungKyNamTruoc: null,
        thucHienLuyKeDenThangBc: null,
        uocThucHienThangKeTiep: null,
        uocThucHienLuyKe: null,
        uocThucHienLuyKeSoVoiKeHoach: null,
        ghiChu: null,
        idKy: null,
        stt: null,
        enabled: null,
    }
}

export const baocaoKtxhModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
    newExportModel,
    errorsExport,
}


